import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { GET, PATCH, POST, PUT } from "../../services/axiosInstance";
import { route } from "../../services/apiRoutes";

const initialState = {
  isLoading: false,
  isSuccess: false,
  isError: false,
  error: null,
  isCorporateFlow: true,
  entity: "",
  activeStep: 0, // while reseting set null
  applicantActiveStep: 0,
  kycVerificationActiveStep: 0,
  applicantTotal: 0,
  createBookingData: {},
  enquiryDetails: {},
  applicantData: {},
  companyData: {},
  gstDetailsData: {},
  applicantPdf: {},
  termsAndCondition: {},
  masterData: {},
  referralList: [],
  reviewActiveStep: 0,
  showReferralModal: false,
  showMobileStepper: false,
  isAgreedOnTerms: false,
  isFromPreview: { value: false, index: null },
  stepsCompleted: {},
  projectBrandImage: "",
  applicantEditPreview: false,
  checkFirstStepCompleted: false,
  applicantActiveStep1: 0,
  applicantActiveStep2: 0,
  referralDetails: {},
  eSignature: false,
  offline: false,
  EOIBooking: false,
  stepEOI: 0,
  bookingDocuments: {},
  corporateApplicantMissing: false,
  shouldVerifyDigilockerOnReturn: false,
  hasContinuedAsMinor: false,
  showSaveAndPreview: false,
  hasContinuedAsMinorModal: false,
  multiBookingListData: {},
  groupApplicants: [],
  officeUseData: {},
  voucherApplicantsData: {},
};

export const getApplicantDetails = createAsyncThunk(
  "applicantData",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_BOOKING_DATA, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getApplicantPdf = createAsyncThunk(
  "applicantPdf",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_BOOKING_PDF, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const createBooking = createAsyncThunk(
  "createBooking",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.CREATE_BOOKING_API_NEW, payload);
      if (res?.response?.success) {
        thunkAPI.dispatch(setActiveStep(0));
        thunkAPI.dispatch(getApplicantDetails(`/${payload?.opportunityId}`));
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getOppprtunityDetails = createAsyncThunk(
  "enquiryDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_OPPORTUNITY_DETAILS, payload);
      if (res?.response?.success) {
        return res?.response?.response || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateApplicantDetails = createAsyncThunk(
  "updateApplicantData",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.newBookingForm?.activeStep]: true,
        };
        thunkAPI.dispatch(setStepsCompleted(completedSteps));
        if (!value?.freezeCurrentStep) {
          thunkAPI.dispatch(
            setActiveStep(state?.newBookingForm?.activeStep + 1)
          );
        }
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`));
        return res?.response;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateOtherDetails = createAsyncThunk(
  "updateOtherDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.newBookingForm?.activeStep]: true,
        };
        thunkAPI.dispatch(setStepsCompleted(completedSteps));
        thunkAPI.dispatch(setActiveStep(state?.newBookingForm?.activeStep + 1));

        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`));
        return res?.response;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

// funtion for applicant 1 to 4 steps
export const updateApplicantDetailsForm = createAsyncThunk(
  "updateApplicantDetailsForm",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`));
        return res;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getTermsAndCondition = createAsyncThunk(
  "termsAndCondition",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_TERMS_AND_CONDITION, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getMasterDataList = createAsyncThunk(
  "getMasterDataList",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_MASTER_DATA, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSaveForLater = createAsyncThunk(
  "updateSaveForLater",
  async (value, thunkAPI) => {
    try {
      const { path, payload, opportunityId, method = "PATCH" } = value;
      let res;

      if (method === "POST") {
        res = await POST(path, payload);
      } else {
        res = await PATCH(path, payload);
      }
      if (res?.status === 200) {
        thunkAPI.dispatch(getApplicantDetails(`/${opportunityId}`));
        return res?.response;
      } else {
        if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
          console.log("error", res);
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateReviewAndSign = createAsyncThunk(
  "updateReviewAndSign",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        state.isAgreedOnTerms = value?.payload?.isAgreedOnTerms;
        thunkAPI.dispatch(
          getApplicantDetails(`/${value?.payload?.opportunityId}`)
        );
        return res?.response;
      } else {
        if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
          console.log("error", res);
        }
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getPresignedUrl = createAsyncThunk(
  "getPresignedUrl",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.GET_PRESIGNED_URL, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const uploadFile = createAsyncThunk(
  "uploadFile",
  async (payload, thunkAPI) => {
    try {
      const res = await PUT(payload.presignedUrl, payload.file, {
        headers: {
          "Content-Type": payload.file.type,
        },
      });
      if (res?.response?.status === 200) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteImage = createAsyncThunk(
  "deleteImage",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.DELETE_IMAGE, payload);
      if (res?.response?.success) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateImageData = createAsyncThunk(
  "updateImageData",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.UPDATE_DELETE_IMAGE, payload);
      if (res?.status === 201) {
        thunkAPI.dispatch(getApplicantDetails(`/${payload?.oppId}`));
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const signForApplicant = createAsyncThunk(
  "signForApplicant",
  async (value, thunkAPI) => {
    try {
      const res = await POST(value?.path, value?.payload);
      // if(res?.status === 200 || res?.status === 201) {
      //  return res?.response
      // } else {
      //   if(res?.status === 400 || res?.status === 404 || res?.status === 500) {
      //     console.log('error', res)
      //   }
      // }
      if (res?.response?.success) {
        return res?.response?.response;
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const saveRatingFeedback = createAsyncThunk(
  "saveRatingFeedback",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.SAVE_RATING_FEEDBACK, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteBooking = createAsyncThunk(
  "deleteBooking",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.DELETE_BOOKING, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getBookingDocuments = createAsyncThunk(
  "getBookingDocuments",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_BOOKING_DOCUMENTS, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateReferralDetails = createAsyncThunk(
  "updateReferralData",
  async (value, thunkAPI) => {
    try {
      const res = await POST(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.newBookingForm?.activeStep]: true,
        };
        thunkAPI.dispatch(setStepsCompleted(completedSteps));
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`));
        return res?.response?.response;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchCompanyDetails = createAsyncThunk(
  "fetchCompanyDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.GET_COMPANY_DETAILS, payload);
      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      } else {
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateSignatory = createAsyncThunk(
  "updateSignatory",
  async (value, thunkAPI) => {
    try {
      const response = await PATCH(value?.path, value?.payload);
      if (response?.response?.data?.success) {
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`));
        return response?.response?.data?.response?.data || {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const deleteSignatory = createAsyncThunk(
  "deleteSignatory",
  async (value, thunkAPI) => {
    try {
      const response = await PATCH(value?.path, value?.payload);
      if (response?.response?.data?.success) {
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`));
        return response?.response?.data?.response?.data || {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateCompanyDocuments = createAsyncThunk(
  "updateCompanyDocuments",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.newBookingForm?.activeStep]: true,
        };
        thunkAPI.dispatch(setStepsCompleted(completedSteps));
        thunkAPI.dispatch(setActiveStep(state?.newBookingForm?.activeStep + 1));
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`));
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const fetchDigiLockerURL = createAsyncThunk(
  "fetchDigiLockerURL",
  async (payload, thunkAPI) => {
    try {
      const response = await POST(route.GET_DIGILOCKER_URL, payload);
      if (response?.response?.success) {
        return response?.response?.response?.data || {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const createReferrals = createAsyncThunk(
  "createReferrals",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.CREATE_REFERRALS, payload);
      if (res?.status === 201) {
        return res.response;
      }
      if (res?.status === 400 || res?.status === 404 || res?.status === 500) {
        console.log("error", res);
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateReviewDetails = createAsyncThunk(
  "updateReviewDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(value?.path, value?.payload);
      if (res?.status === 200) {
        let state = thunkAPI.getState();
        let completedSteps = {
          ...state.stepsCompleted,
          [state?.newBookingForm?.activeStep]: true,
        };
        thunkAPI.dispatch(setStepsCompleted(completedSteps));
        thunkAPI.dispatch(getApplicantDetails(`/${value?.opportunityId}`));
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getReferralDetails = createAsyncThunk(
  "referralDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.REFERRAL_DETAILS, payload);
      if (res?.response.success) {
        return res?.response?.response?.data || {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updatePaymentDetails = createAsyncThunk(
  "updatePaymentDetails",
  async ({ oppId, payload }, thunkAPI) => {
    try {
      const res = await PATCH(`${route.UPDATE_PAYMENT_DATA}`, payload);

      if (res?.status === 200) {
        return {
          success: true,
          data: res?.response,
        };
      } else {
        // Log and return full error structure
        console.error("❌ API error response:", res);
        return thunkAPI.rejectWithValue({
          success: false,
          errors: res?.errors || {
            statusCode: res?.status,
            message: res?.message || "Unknown error",
          },
        });
      }
    } catch (error) {
      console.error("❌ Exception in updatePaymentDetails:", error);
      return thunkAPI.rejectWithValue({
        success: false,
        errors: error?.response?.data || {
          statusCode: 500,
          message: error.message || "Unexpected error",
        },
      });
    }
  }
);

export const updateCompanyDetails = createAsyncThunk(
  "updateCompanyDetails",
  async (value, thunkAPI) => {
    try {
      const res = await PATCH(route.UPDATE_COMPANY_DETAILS, value?.payload);
      if (res?.status === 200) {
        return res?.response?.data;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const deletePaymentDetails = createAsyncThunk(
  "deletePaymentDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.DELETE_BOOKINGS_TRANSACTIONS, payload);
      if (res?.response?.success) {
        return res?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const getImageDetailsOCR = createAsyncThunk(
  "getImageDetailsOCR",
  async (payload, thunkAPI) => {
    try {
      const response = await POST(route.GET_IMAGE_DETAILS_OCR, payload);
      if (response?.response?.success) {
        return response?.response?.response?.data || {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const verifyDigilockerStatus = createAsyncThunk(
  "verifyDigilockerStatus",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.VERIFY_DIGILOCKER_STATUS, payload);
      if (res?.response?.success) {
        return res?.response?.response || {};
      }
      return thunkAPI.rejectWithValue(res?.response?.response);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getMultiBookingList = createAsyncThunk(
  "multiBookingList",
  async (payload, thunkAPI) => {
    try {
      const { groupId, page, limit, search } = payload;

      const params = new URLSearchParams();

      if (groupId) params.append("id", groupId);
      if (page) params.append("page", page);
      if (limit) params.append("limit", limit);
      if (search) params.append("search", search);

      const res = await GET(`${route.MULTI_BOOKING_LIST}?${params.toString()}`);

      if (res?.response?.success) {
        return res?.response?.response?.data || {};
      }

      return thunkAPI.rejectWithValue("Failed to fetch data");
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const getGroupApplicants = createAsyncThunk(
  "getGroupApplicants",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(`${route.GROUP_APPLICANTS}?id=${payload}`);
      return res?.response?.response?.data?.applicants || [];
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const updateApplicantMapping = createAsyncThunk(
  "updateApplicantMapping",
  async (value, thunkAPI) => {
    try {
      const response = await PUT(value?.path, value?.payload);
      if (response?.response?.data?.success) {
        return response?.response?.data?.response?.data || {};
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const officeUseDetails = createAsyncThunk(
  "officeUseDetails",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(route.GET_OFFICE_USE_DETAILS, payload);
      if (res?.status === 200 || res?.status === 404) {
        if (res?.response?.success) {
          return res?.response?.response?.data || {};
        }
      }
      return thunkAPI.rejectWithValue('Failed to fetch applicant details');
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data || 'Unknown error');
    }
  }
);
export const getVoucherApplicants = createAsyncThunk(
  "getVoucherApplicants",
  async (payload, thunkAPI) => {
    try {
      const res = await GET(`${route.GET_VOUCHER_APPLICANsTS}${payload}`);
      return res?.response?.response?.data || [];
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);
export const mapVoucherApplicants = createAsyncThunk(
  "mapVoucherApplicants",
  async (value, thunkAPI) => {
    try {
      const response = await POST(
        route.MAP_VOUCHER_APPLICANTS, 
        value.payload
      );

      return response?.response?.response?.data || [];
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

export const pushApplicantData = createAsyncThunk(
  "pushApplicantData",
  async (payload, thunkAPI) => {
    try {
      const res = await POST(route.PUSH_APPLICANT_DATA, payload);
      if (res?.response?.success) {
        return res?.response?.response;
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.response?.data);
    }
  }
);

const handleAsyncThunk = (builder, thunk, options = {}) => {
   const {
    dataKey,
    skipLoading = false,
    resetOnReject = false,
    resetValue = null,
  } = options;

  builder
    .addCase(thunk.pending, (state) => {
      if (!skipLoading) state.isLoading = true;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      if (!skipLoading) state.isLoading = false;
      state.isError = false;
      state.isSuccess = true;
      if (dataKey) state[dataKey] = action?.payload;
    })
    .addCase(thunk.rejected, (state, action) => {
      if (!skipLoading) state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.error = action?.payload?.error;
      if (resetOnReject && dataKey) {
        state[dataKey] = resetValue;
      }
    });
};

export const newBookingFormSlice = createSlice({
  name: "newBookingForm",
  initialState,
  reducers: {
    clearState: () => initialState,
    setIsCorporateFlow: (state, action) => {
      state.isCorporateFlow = action?.payload;
    },
    setEntity: (state, action) => {
      state.entity = action?.payload;
    },
    setActiveStep: (state, action) => {
      state.activeStep = action?.payload;
    },
    setApplicantActiveStep: (state, action) => {
      state.applicantActiveStep = action.payload;
    },
    setKycVerificationActiveStep: (state, action) => {
      state.kycVerificationActiveStep = action.payload;
    },
    setApplicantTotal: (state, action) => {
      state.applicantTotal = action.payload;
    },
    setReferralList: (state, action) => {
      state.referralList = action.payload;
    },
    setReviewActiveStep: (state, action) => {
      state.reviewActiveStep = action.payload;
    },
    setIsError: (state, action) => {
      state.isError = action.payload;
    },
    setShowMobileStepper: (state, action) => {
      state.showMobileStepper = action.payload;
    },
    setShowReferralModal: (state, action) => {
      state.showReferralModal = action.payload;
    },
    setCheckFirstStepCompleted: (state, action) => {
      state.checkFirstStepCompleted = action.payload;
    },
    setApplicantActiveStep1: (state, action) => {
      state.applicantActiveStep1 = action.payload;
    },
    setApplicantActiveStep2: (state, action) => {
      state.applicantActiveStep2 = action.payload;
    },
    setESignature: (state, action) => {
      state.eSignature = action.payload;
    },
    setOffline: (state, action) => {
      state.offline = action.payload;
    },
    setResetData: (state, action) => {
      state.isCorporateFlow = true;
      state.entity = "";
      state.activeStep = 0;
      state.applicantActiveStep = 0;
      state.kycVerificationActiveStep = 0;
      state.applicantActiveStep1 = 0;
      state.applicantActiveStep2 = 0;
      state.applicantTotal = 0;
      state.reviewActiveStep = 0;
      state.applicantData = {};
      state.showReferralModal = false;
      state.isError = false;
      state.isLoading = false;
      state.applicantEditPreview = false;
      state.gstDetailsData = null;
      state.showSaveAndPreview = false;
    },
    setIsFromPreview: (state, action) => {
      state.isFromPreview = action.payload;
    },
    setStepsCompleted: (state, action) => {
      state.stepsCompleted = action.payload;
    },
    setProjectBrandImage: (state, action) => {
      state.projectBrandImage = action.payload;
    },
    setIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    setEditPreviewApplicant: (state, action) => {
      state.applicantEditPreview = action.payload;
    },
    setShowSaveAndPreview: (state, action) => {
      state.showSaveAndPreview = action.payload;
    },
    setEOIBooking: (state, action) => {
      state.EOIBooking = action.payload;
    },
    setStepEOI: (state, action) => {
      state.stepEOI = action.payload;
    },
    setCorporateApplicantMissing: (state, action) => {
      state.corporateApplicantMissing = action.payload;
    },
    resetGstDetailsData: (state) => {
      state.gstDetailsData = null;
    },
    setHasContinuedAsMinor: (state, action) => {
      state.hasContinuedAsMinor = action?.payload;
    },
    setHasContinuedAsMinorModal: (state, action) => {
      state.hasContinuedAsMinorModal = action?.payload;
    },
    resetMultiBookingListData: (state) => {
      state.multiBookingListData = {};
    },
    resetGroupApplicants: (state) => {
      state.groupApplicants = [];
    },
    setProjectId: (state, action) => {
      state.projectId = action.payload;
    },
    setBrandId: (state, action) => {
      state.brandId = action.payload;
    },
    clearEnquiryDetails: (state) => {
      state.enquiryDetails = {};
    },
  },
  extraReducers: (builder) => {
    handleAsyncThunk(builder, getApplicantDetails, {
      dataKey: "applicantData",
      resetOnReject: true,
      resetValue: {},
    });
    handleAsyncThunk(builder, fetchCompanyDetails, {
      dataKey: "gstDetailsData",
      skipLoading: true,
      resetOnReject: true,
      resetValue: {},
    });
    handleAsyncThunk(builder, getApplicantPdf, { dataKey: "applicantPdf" });
    handleAsyncThunk(builder, createBooking, { dataKey: "createBookingData" });
    handleAsyncThunk(builder, getReferralDetails, {
      dataKey: "referralDetails",
      resetOnReject: true,
      resetValue: {},
    });
    handleAsyncThunk(builder, createReferrals);
    handleAsyncThunk(builder, updateReviewDetails);
    handleAsyncThunk(builder, getOppprtunityDetails, {
      dataKey: "enquiryDetails",
      resetOnReject: true,
      resetValue: {}, 
    });
    handleAsyncThunk(builder, updateApplicantDetails);
    handleAsyncThunk(builder, getTermsAndCondition, {
      dataKey: "termsAndCondition",
      resetOnReject: true,
      resetValue: {}, 
    });
    handleAsyncThunk(builder, getMasterDataList, { dataKey: "masterData" });
    handleAsyncThunk(builder, updateApplicantDetailsForm);
    handleAsyncThunk(builder, updateReviewAndSign);
    handleAsyncThunk(builder, signForApplicant);
    handleAsyncThunk(builder, saveRatingFeedback);
    handleAsyncThunk(builder, deleteBooking);
    handleAsyncThunk(builder, getBookingDocuments, {
      dataKey: "bookingDocuments",
      resetOnReject: true,
      resetValue: {}, 
    });
    handleAsyncThunk(builder, updateCompanyDocuments);
    handleAsyncThunk(builder, fetchDigiLockerURL);
    handleAsyncThunk(builder, updateSignatory);
    handleAsyncThunk(builder, deleteSignatory);
    handleAsyncThunk(builder, updateCompanyDetails);
    handleAsyncThunk(builder, getImageDetailsOCR);
    handleAsyncThunk(builder, updatePaymentDetails);
    handleAsyncThunk(builder, updateSaveForLater);
    handleAsyncThunk(builder, verifyDigilockerStatus);
    handleAsyncThunk(builder, getMultiBookingList, {
      dataKey: "multiBookingListData",
      resetOnReject: true,
      resetValue: {}, 
    });
    handleAsyncThunk(builder, getGroupApplicants, {
      dataKey: "groupApplicants",
      resetOnReject: true,
      resetValue: {},
    });
    handleAsyncThunk(builder, updateApplicantMapping);
    handleAsyncThunk(builder, officeUseDetails, {
      dataKey: "officeUseData",
      resetOnReject: true,
      resetValue: {},
    });
    handleAsyncThunk(builder, getVoucherApplicants, {
      dataKey: "voucherApplicantsData",
      resetOnReject: true,
      resetValue: {},
    });
    handleAsyncThunk(builder, pushApplicantData);
  },
});

export const {
  clearState,
  setIsCorporateFlow,
  setEntity,
  setActiveStep,
  setApplicantActiveStep,
  setApplicantTotal,
  setReferralList,
  setReviewActiveStep,
  setIsError,
  setShowMobileStepper,
  setShowReferralModal,
  setResetData,
  setIsFromPreview,
  setStepsCompleted,
  setProjectBrandImage,
  setIsLoading,
  setEditPreviewApplicant,
  setCheckFirstStepCompleted,
  setApplicantActiveStep1,
  setApplicantActiveStep2,
  setESignature,
  setOffline,
  setEOIBooking,
  setStepEOI,
  resetGstDetailsData,
  setCorporateApplicantMissing,
  setKycVerificationActiveStep,
  setHasContinuedAsMinor,
  setShowSaveAndPreview,
  setHasContinuedAsMinorModal,
  resetMultiBookingListData,
  resetGroupApplicants,
  setProjectId,
  setBrandId,
  clearEnquiryDetails,
} = newBookingFormSlice.actions;
export default newBookingFormSlice.reducer;
